import { ConceptInvoicingModel } from 'src/app/models/invoicing/concept-invoicing.model';
import { ArticleModel } from 'src/app/models/archive/article.model';
import { InvoicingModelModel } from 'src/app/models/invoicing/invoicing-model.model';
import { ConstructionSiteModel } from './construction-site.model';
import { AccountingModelModel } from '../management/accounting-model.model';

export class CostCenterModel {
  costCenterId: number = 0;
  branchId: number = 0;
  code: number = 0;
  alterCode: string | null = "";
  name: string = '';
  costCenterTypeId: number = 0;
  clientId: number = 0;
  constructionSiteId: number = 0;
  constructionSite: ConstructionSiteModel = new ConstructionSiteModel();
  priceListId: number = 0;
  swInvoiceM2: boolean = false;
  unitValueM2: number = 0;
  swFixedQuota: boolean = false;
  valueFixedQuota: number = 0;
  invoicingModelId: number = 0;
  invoicingModel: InvoicingModelModel = new InvoicingModelModel();
  ivaTypeId: number = 0;
  administrationRate: number = 0;
  incidentalRate: number = 0;
  utilityRate: number = 0;
  articleId: number | null = null;
  article: ArticleModel = new ArticleModel()
  conceptInvoicingId: number | null = null;
  conceptInvoicing: ConceptInvoicingModel = new ConceptInvoicingModel();
  ratePromptPayment: number = 0;
  observation: string | null = null;
  swAdvanceInvoice: boolean = false;
  advanceInvoiceOption: number | null = null;
  accountingModelId: number = 0;
  accountingModel: AccountingModelModel = new AccountingModelModel();
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}
